/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetypenotallowed5Inputs */

const en_coinvestments_dataroom_filetypenotallowed5 = /** @type {(inputs: Coinvestments_Dataroom_Filetypenotallowed5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type not allowed`)
};

/**
* | output |
* | --- |
* | "File type not allowed" |
*
* @param {Coinvestments_Dataroom_Filetypenotallowed5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetypenotallowed5 = /** @type {((inputs?: Coinvestments_Dataroom_Filetypenotallowed5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetypenotallowed5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetypenotallowed5(inputs)
});
export { coinvestments_dataroom_filetypenotallowed5 as "coInvestments_dataRoom_fileTypeNotAllowed" }